export default __webpack_public_path__ + "static/media/schedule.48200f80.svg";